module.exports = __webpack_public_path__ + "img/nav-design-ringsets.654d6fb.jpg";